<template>
  <div class="card-grid-display">
    <v-card class="mx-auto agenda-meeting-card" width="287" v-for="n in 1" :key="n">
      <v-card-text class="card-grid-display">
        <v-row no-gutters>
          <span class="text-h6 font-weight-bold primary--text">
            2023/1/19 <br />00:00 PM - 00:00 PM
          </span>
        </v-row>
        <v-row no-gutters>
          <span class="text-subtitle-1 font-weight-bold">会議タイトル1</span>
        </v-row>
        <v-row no-gutters>
          <span class="text--topic"> 東京本社会議室A </span>
        </v-row>
        <v-row no-gutters>
          <span class="text--topic">on-site meeting</span>
        </v-row>
        <v-row no-gutters>
          <v-icon size="20" class="mr-2">mdi-attachment</v-icon>
          <span class="primary--text">3</span>
        </v-row>
        <v-row no-gutters>
          <v-icon size="20" class="mr-2">mdi-file-document</v-icon>
          <span class="primary--text">XXXXXXXXXX議事録</span>
        </v-row>
        <v-row no-gutters>
          <v-icon size="20" class="mr-2">mdi-file-document</v-icon>
          <span class="primary--text">XXXXXXXXXX議事録</span>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AgendaMeetingCard",
};
</script>

<style scoped>
.agenda-meeting-card .v-card__text {
  padding: 16px !important;
  color: var(--v-darkCharcoal-base) !important;
}

.card-grid-display {
  display: grid;
  grid-gap: 8px;
}
</style>